module.exports = __webpack_public_path__ + "img/result-liveness.2cd37de4.svg";